import * as React from 'react';

import { createIcon } from '../Icon';
export const ArchiveIcon = createIcon(
  <React.Fragment>
    <polyline points="21 8 21 21 3 21 3 8" />
    <rect x={1} y={3} width={22} height={5} />
    <line x1={10} y1={12} x2={14} y2={12} />
  </React.Fragment>,
  'ArchiveIcon'
);
